module.exports = __webpack_public_path__ + "static/img/rewardInstruction.b82089d0.png";